import { axios } from "../lib/axios";

/**
 * Prioritize variants based on HPO terms
 * @param {Array} hpoTerms - Array of HPO terms to prioritize by
 * @param {number} sampleId - ID of the sample to prioritize
 * @return {Promise} Prioritized variants response
 */
const prioritizeVariantsByHPO = (hpoTerms, sampleId) => {
  return axios.post(`/prioritize-variants/`, {
    hpo_terms: hpoTerms,
    sample_id: sampleId,
  });
};

/**
 * Check prioritization status
 * @param {number} sampleId - ID of the sample
 * @return {Promise} Status response with is_prioritized field
 */
const checkPrioritizationStatus = (sampleId) => {
  return axios.get(`/prioritize-variants/${sampleId}/status/`);
};

export default prioritizeVariantsByHPO;
export { prioritizeVariantsByHPO, checkPrioritizationStatus };
